export default [

  // 国語
  {id: '101', categoryId: '1', children: ['110', '130'], maxScore: 200, name: '国・現古漢'},
  {id: '102', categoryId: '1', children: ['110', '130'], maxScore: 200, name: '国・現古'},
  {id: '103', categoryId: '1', children: ['110'], maxScore: 200, name: '国・現のみ'},
  {id: '110', categoryId: '1', maxScore: 100, name: '現代文'},
  {id: '130', categoryId: '1', maxScore: 200, name: '現古'},

  // 数学
  {id: '203', categoryId: '2', maxScore: 200, name: '数学X'},
  {id: '202', categoryId: '2', maxScore: 200, name: '数学Y'},
  {id: '201', categoryId: '2', maxScore: 200, name: '数学Z'},

  // 英語
  {id: '301', categoryId: '3', maxScore: 200, name: '英語'},

  // 地歴公民
  {id: '412', categoryId: '4', maxScore: 100, name: '世界史Ｂ'},
  {id: '422', categoryId: '4', maxScore: 100, name: '日本史Ｂ'},
  {id: '432', categoryId: '4', maxScore: 100, name: '地理Ｂ'},
  {id: '453', categoryId: '4', maxScore: 100, name: '現代社会'},
  {id: '451', categoryId: '4', maxScore: 100, name: '倫理'},
  {id: '452', categoryId: '4', maxScore: 100, name: '政治経済'},
  {id: '454', categoryId: '4', maxScore: 100, name: '倫・政'},

  // 理科
  {id: '512', categoryId: '5', maxScore: 50 , name: '物理基礎'},
  {id: '522', categoryId: '5', maxScore: 50 , name: '化学基礎'},
  {id: '532', categoryId: '5', maxScore: 50 , name: '生物基礎'},
  {id: '542', categoryId: '5', maxScore: 50 , name: '地学基礎'},
  {id: '513', categoryId: '5', maxScore: 100, name: '物理'},
  {id: '523', categoryId: '5', maxScore: 100, name: '化学'},
  {id: '533', categoryId: '5', maxScore: 100, name: '生物'},
  {id: '543', categoryId: '5', maxScore: 100, name: '地学'},
];



// WEBPACK FOOTER //
// ./src/js/constants/mockSubjects.js